import script from "./DuplicateCustomDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateCustomDashboard.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateCustomDashboard.vue?vue&type=style&index=0&id=fc4325c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4325c4"]])

export default __exports__